import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

interface MobileRegisterGraphProps {
  data: {
    items?: {
      Name: string;
      iOSValue?: number | null;
      AndroidValue?: number | null;
    }[];
  };
}

export const MoileRegisterGraph = ({ data }: MobileRegisterGraphProps) => {
  const safeItems = Array.isArray(data?.items) ? data.items : [];

  const categories = safeItems.map((item) => item.Name || "");
  const iosData = safeItems.map((item) => item.iOSValue ?? 0);
  const androidData = safeItems.map((item) => item.AndroidValue ?? 0);

  const options: Highcharts.Options = {
    chart: {
      type: "column",
    },
    title: {
      text: "Registered iOS vs Android Users",
      align: "center",
      style: {
        fontSize: "13px",
      },
    },
    subtitle: {
      text: "Source: Internal App Analytics",
    },
    xAxis: {
      categories,
      crosshair: true,
      accessibility: {
        description: "Months",
      },
      labels: {
        style: {
          fontSize: "10px",
        },
        step: 1, // Force all labels to show
        autoRotation: [], // Disable automatic rotation (correct type)
      },
    },

    credits: {
      enabled: false,
    },
    yAxis: {
      min: 0,
      title: {
        text: "Registrations",
        style: {
          fontSize: "11px", // ✅ Title font size
        },
      },
      labels: {
        style: {
          fontSize: "12px", // ✅ Y-axis labels font size
        },
        formatter: function () {
          const value = this.value as number;

          return value >= 1000 ? `${value / 1000}K` : `${value}`;
        },
      },
    },

    tooltip: {
      shared: true,
      valueSuffix: " registrations",
      style: {
        fontSize: "12px", // Increase this to your preferred size
      },
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: "iOS",
        type: "column",
        data: iosData,
      },
      {
        name: "Android",
        type: "column",
        data: androidData,
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
